import type * as lazyIndex from './lazyIndex';
import { createLazyComponent, LazyModule, type LazyComponent } from 'owa-bundling';
import { type TasksHubMenuButtonProps } from './components/TasksHubMenuButton.Props';
import type { TasksHubProps } from './components/TasksHub';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "CopilotChatTasksHub" */ './lazyIndex'),
    { name: 'CopilotChatTasksHub' }
);

export const LazyTasksHub: LazyComponent<TasksHubProps, undefined> = createLazyComponent(
    lazyModule,
    m => m.TasksHub
);

export const LazyTasksHubMenuButton: LazyComponent<TasksHubMenuButtonProps, undefined> =
    createLazyComponent(lazyModule, m => m.TasksHubMenuButton);
